export default __webpack_public_path__ + "static/media/cabos.ea01671f.png";